import React from 'react';
import styles from './Path.module.scss';
import PropTypes from 'prop-types';
import { Button } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

export default function Path({
    currentStep,
    steps,
    onCurrentPathChange, loading = false, readOnly = false
}) {
    const [selected, setSelected] = React.useState(null);

    const markAsCurrent = () => {
        const currentStepObj = steps.find(step => step.code === selected);
        onCurrentPathChange(currentStepObj);
        setSelected(null);
    };

    const handlePathClick = (step) => {
        if (!readOnly) {
            setSelected(step.code);
        }
    };

    React.useEffect(() => {
        if (!loading) setSelected(null);
    }, [loading]);

    const currentIndex = steps.findIndex(step => step.code === currentStep);

    const getStepClass = (index, code) => {
        const classes = [styles.pathStep];
        if (index < currentIndex) classes.push(styles.completed);
        else if (index === currentIndex) classes.push(styles.current);
        if (selected === code) classes.push(styles.selected);
        return classes.join(' ');
    };

    return (
        <div className={styles.pathWrapper}>
            <div className={styles.pathContainer}>
                {steps.map((stepItem, index) => (
                    <div
                        key={stepItem.code}
                        title={stepItem.nom}
                        className={getStepClass(index, stepItem.code)}
                        onClick={() => handlePathClick(stepItem)}
                    >
                        <div className={styles.pathLabel}>
                            {index < currentIndex && <CheckOutlined style={{ marginRight: 4, fontSize: 10 }} />}
                            {stepItem.nom}
                        </div>
                    </div>
                ))}
            </div>
            {!readOnly && (
                <div className={styles.pathActions}>
                    <span className={styles.stepInfo}>
                        {selected
                            ? `Passer à : ${steps.find(s => s.code === selected)?.nom}`
                            : 'Cliquez sur une étape pour la sélectionner'}
                    </span>
                    <Button
                        type="primary"
                        size="small"
                        disabled={!selected}
                        loading={loading}
                        onClick={markAsCurrent}
                    >
                        Enregistrer
                    </Button>
                </div>
            )}
        </div>
    );
}

Path.propTypes = {
    currentStep: PropTypes.string.isRequired,
    steps: PropTypes.array.isRequired,
    onCurrentPathChange: PropTypes.func.isRequired,
    loading: PropTypes.bool,
    readOnly: PropTypes.bool,
};
